// extracted by mini-css-extract-plugin
export default {"horizontal":"Participants_horizontal__vVgAN","vertical":"Participants_vertical__fpIFO","label":"Participants_label__nULLW"};